import React from 'react';

import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { WarehouseDocumentPlace } from '@app/models/orders';

import { getPlaceType, sumPlaces } from '../../data/cargo';

interface IProps {
  places?: WarehouseDocumentPlace[] | null;
  align?: 'flex-start' | 'flex-end';
}

export const Places: React.FC<IProps> = ({ places, align = 'flex-end' }) => {
  const ordersT = useTranslation(NSKeys.counterpartyOrders);

  if (!places || !places.length) {
    return <>—</>;
  }

  const breakdown = places
    .map((place) => {
      const type = getPlaceType(place.type);
      return `${type ? ordersT.t(`placeType.${type}` as const) : place.type} ${place.amount}`;
    })
    .join(' · ');

  return (
    <Flex vertical align={align}>
      <Typography.Text strong>{sumPlaces(places)}</Typography.Text>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {breakdown}
      </Typography.Text>
    </Flex>
  );
};
